import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import queryString from "query-string";

import AllDataClass from "pages/common/AllDataClass";
import i18n from "locales/i18n";

const values = queryString.parse(window.location.search);
const lang = values.lang;

if (lang === "en") {
  AllDataClass.setLanguage("en");
} else {
  AllDataClass.setLanguage("ko");
}

i18n.changeLanguage(lang as string);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);
